import { render, staticRenderFns } from "./premiumTemplates.vue?vue&type=template&id=3ee3c46e&scoped=true&"
import script from "./premiumTemplates.vue?vue&type=script&lang=js&"
export * from "./premiumTemplates.vue?vue&type=script&lang=js&"
import style0 from "./premiumTemplates.vue?vue&type=style&index=0&id=3ee3c46e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee3c46e",
  null
  
)

export default component.exports